module.exports = __webpack_public_path__ + "static/media/icon_manager_new97a4bf515e3fabdc46f3c380d70e5ec8.webp";